import React, { useState, useEffect } from "react";
import Icon from "./Icon/Icon";
import Heart from "../heart";

function dbg(value) {
    // console.log(value)
    return value
}

export default function CartButton(props) {
    let ID = props.elem?.dataset?.id ? Number(props.elem.dataset.id) : props.id;
    let propsSelected = props.elem?.dataset?.selected
        ? props.elem.dataset.selected
        : props.selected;
    let propsOwned = props.elem?.dataset?.owned ? Boolean(props.elem.dataset.owned) : props.owned;
    // singleButton is for showing only cart icon and used in the Search Result
    let singleButton = props.elem?.dataset?.singleButton
        ? Boolean(props.elem.dataset.singleButton)
        : props.singleButton;

    let showHeart = props.elem?.dataset?.showHeart
        ? Boolean(props.elem.dataset.showHeart) != false
        : props.showHeart != false;

    let loggedin = window.Dibook.loggedin ?? false;

    let pointDiscountQuantity = props.elem?.dataset?.pointDiscountQuantity
        ? Number(props.elem.dataset.pointDiscountQuantity)
        : props.pointDiscountQuantity;
    let pointDiscountType = props.elem?.dataset?.pointDiscountType
        ? Number(props.elem.dataset.pointDiscountType)
        : props.pointDiscountType;

    let points =
        pointDiscountType == 1
            ? Math.round(pointDiscountQuantity * (props.price * 0.05))
            : pointDiscountType == 2
                ? pointDiscountQuantity
                : Math.round(props.price * 0.05);

    let [selected, setSelected] = useState(propsSelected);
    let [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetching whislist
        window.Dibook.cart
            .fetchCart()
            .then(payload => {
                setLoading(false);

                let cart = payload.content?.data?.cart;

                if (itemInCart(ID, cart)) {
                    setSelected(true);
                } else {
                    setSelected(false);
                }
            })
            .catch(error => console.log(error));

        let addingSubId = window.Dibook.cart.on("itemsAdding", payload => {
            if (payload.includes(ID)) setLoading(true);
        });

        let addedSubId = window.Dibook.cart.on("itemsAdded", payload => {
            setLoading(false);
            let cart = payload.content?.data?.cart;

            if (itemInCart(ID, cart)) {
                setSelected(true);
            } else {
                setSelected(false);
            }

            if (payload.status === 403) showLogin();
        });

        let removingSubId = window.Dibook.cart.on("itemsRemoving", payload => {
            if (payload.includes(ID)) setLoading(true);
        });

        let removedSubId = window.Dibook.cart.on("itemsRemoved", payload => {
            setLoading(false);
            let cart = payload.content?.data?.cart;

            if (itemInCart(ID, cart)) {
                setSelected(true);
            } else {
                setSelected(false);
            }

            if (payload.status === 403) showLogin();
        });

        return () => {
            window.Dibook.cart.off("itemsAdding", addingSubId);
            window.Dibook.cart.off("itemsAdded", addedSubId);
            window.Dibook.cart.off("itemsRemoving", removingSubId);
            window.Dibook.cart.off("itemsRemoved", removedSubId);
        };
    }, []);

    const className = `label ${props.layout === "compact" ? "compact" : ""}`;

    return (
        <Wrapper {...props}>
            <div
                className={
                    "cartbutton" +
                    (selected ? ` clicked cartbutton--selected` : "") +
                    (propsOwned ? " cartbutton--owned" : "") +
                    (loading ? " cartbutton--loading" : "") +
                    (singleButton ? " cartbutton--single" : "")
                }
            >
                {!propsOwned ? (
                    !singleButton ? (
                        <>
                            {props.layout === "full" && (
                                <div className="cartInfo">
                                    <div className="cartInfo__price-box">
                                        {props.oldprice && (
                                            <h6 className="cartInfo__oldPrice">
                                                {window.Dibook.language.formatCurrency(
                                                    props.oldprice
                                                )}
                                            </h6>
                                        )}
                                        <strong className="cartInfo__price">
                                            {window.Dibook.language.formatCurrency(props.price)}
                                        </strong>
                                        {!props.oldprice && points > 0 && !props.discountType && (
                                            <div className="cartInfo__points">{points} pont</div>
                                        )}
                                    </div>
                                    {showHeart ? <Heart id={ID} /> : ''}
                                </div>
                            )}

                            <div
                                className="cartbutton__cart"
                            >
                                <div className={className} 
                                    onClick={className == 'label ' ? () => handleCartButtonClick(ID) : ()=>{}}
                                    style={className == 'label ' ? {cursor: 'pointer'} : {}}
                                    >
                                    {props.layout !== "compact" ? (
                                        propsOwned ? (
                                            <p className={"m-0 owned-text" + (singleButton ? " owned-text_small" : "")}>
                                                Már megvetted
                                            </p>
                                        ) : (
                                            <>
                                                <span
                                                    className="add-to-cart">Kosárba</span>
                                                <span
                                                    style={{pointerEvents: 'none'}}
                                                    className="added">Kosárban</span>
                                            </>
                                        )
                                    ) : (
                                        <>
                                            <div className="prices add-to-cart">
                                                <div>
                                                    {props.oldprice && (
                                                        <div className="prices__old">
                                                            {window.Dibook.language.formatCurrency(
                                                                parseInt(dbg(props.oldprice))
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="prices__new">
                                                        {window.Dibook.language.formatCurrency(
                                                            parseInt(dbg(props.price))
                                                        )}
                                                    </div>
                                                    {!props.oldprice &&
                                                        points > 0 &&
                                                        !props.discountType && (
                                                            <div className="prices__point" style={{ fontWeight: 400, fontSize: '12px' }}>
                                                                {points} pont
                                                            </div>
                                                        )}
                                                </div>
                                                {showHeart ? <Heart id={ID} /> : ''}
                                            </div>
                                            <span className="added">Kosárban</span>
                                        </>
                                    )}
                                    <div
                                        className="cartIcon">
                                        <i className="fa-solid fa-cart-shopping"></i>
                                    </div>
                                    <div
                                        className="cartBox">
                                        <i className="fa-solid fa-box"></i>
                                    </div>
                                </div>

                                <div
                                    onClick={() => handleCartButtonClick(ID)}
                                    className="icon" style={{cursor: 'pointer'}}>
                                    <Icon />
                                </div>
                            </div>
                        </>
                    ) : (
                        <div
                            className="single-icon"
                            onClick={() => handleCartButtonClick(ID)}
                        ></div>
                    )

                ) : (
                    <p className={"m-0 owned-text" + (singleButton ? " owned-text_small" : "")}>
                        Már megvetted
                    </p>
                )}
            </div>
        </Wrapper>
    );

    function itemInCart(itemId, cart) {
        if (!cart) return false;

        let filteredCartItems = cart.filter(item => {
            return item.id === ID ? true : false;
        });

        return filteredCartItems.length > 0 ? true : false;
    }

    function handleCartButtonClick(id) {
        if (loading) return;
        if (selected) return;
        if (propsOwned) return location.href = (props.bookType === 'audio' ? '/profil/hangoskonyv' : '/profil/ebook');
        if (!loggedin) {
            showLogin();
            return;
        }

        window.Dibook.cart.addItems([id]);
    }

    function showLogin() {
        window.$("#loginModal").modal("show");
    }
}

function Wrapper(props) {
    if (props.elem?.className === "widget-cartbutton") {
        return props.children;
    } else {
        return <div className="widget-cartbutton-component">{props.children}</div>;
    }
}
